export const TEST_USER = [
	'test@satschel.com',
	'performance@satschel.com',
	'it@satschel.com',
];
